export const SEARCH_ATOM_KEYS = {
  STORE_KEYWORD: 'keyword',
  KEYWORD_UPDATE: 'keyword_update',
} as const
